import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/72cefc1d/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "ankle-and-foot"
    }}>{`Ankle and Foot`}</h2>
    <ul>
      <li parentName="ul">{`Ankle and foot fracture care`}</li>
      <li parentName="ul">{`Ankle and foot ligament and tendon injuries`}</li>
    </ul>

    </MDXLayout>;
}
MDXContent.isMDXComponent = true;
      